export default __webpack_public_path__ + "static/Tapetsering5-3b884951297c94cc17f61734b2c3b501.jpg";